/**============================================================
*   [sidebarAccordion]
*   description : サイドバーのアコーディオン処理
============================================================*/
const toggleSections = document.querySelectorAll('.js-toggle--section');

if (toggleSections) {
  toggleSections.forEach(target => {
    const toggleButton = target.querySelector('.js-toggle--button');
    if (toggleButton) {
      toggleButton.addEventListener('click', () => {
        const toggleTarget = target.querySelector('.js-toggle--target');
          toggleButton.classList.toggle('active');
          toggleTarget.classList.toggle('active');
      });
    }
  });
}
